var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCantidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.775,
    height: 85.133,
    viewBox: "0 0 95.775 85.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-mail-bulk",
    "data-name": "Icon awesome-mail-bulk",
    d: "M26.6,74.491c-4.257,0-8.513-3.725-10.642-5.321C5.321,61.721,2.128,59.061,0,57.465V79.812a5.321,5.321,0,0,0,5.321,5.321H47.887a5.321,5.321,0,0,0,5.321-5.321V57.465c-2.128,1.6-5.321,4.257-15.962,11.706C35.117,70.767,30.861,74.491,26.6,74.491ZM47.887,42.567H5.321A5.321,5.321,0,0,0,0,47.887v2.66C4.257,53.74,3.725,53.74,19.155,64.914c1.6,1.064,4.789,4.257,7.449,4.257s5.853-3.192,7.449-3.725c15.43-11.174,14.9-11.174,19.155-14.366V47.887A5.321,5.321,0,0,0,47.887,42.567ZM90.454,26.6H37.246a5.321,5.321,0,0,0-5.321,5.321v5.321H47.887A10.657,10.657,0,0,1,58.481,46.86l.048-.037V69.171H90.454a5.321,5.321,0,0,0,5.321-5.321V31.925A5.321,5.321,0,0,0,90.454,26.6ZM85.133,47.887H74.491V37.246H85.133ZM26.6,31.925A10.654,10.654,0,0,1,37.246,21.283H74.491V5.321A5.321,5.321,0,0,0,69.171,0H15.962a5.321,5.321,0,0,0-5.321,5.321V37.246H26.6Z",
    fill: "#e56da1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantidad);
export default __webpack_public_path__ + "static/media/cantidad.fcbb4c88e52cf0301f2c48caf38af478.svg";
export { ForwardRef as ReactComponent };